var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: {
        size: "large",
        dialogStyleOpt: "stickyTop",
        closable: true,
        destroyOnClose: true,
        afterClose: _vm.afterCloseHandle,
      },
      on: { open: _vm.openModalHandle },
    },
    [
      !_vm.isTenant
        ? _c(
            "HKLForm",
            { ref: "form", attrs: { canEdit: _vm.shouldShowSubject } },
            [
              _c(
                "HKLFormItem",
                {
                  attrs: {
                    label: _vm.$t("subject"),
                    required: _vm.isPICAndNotSent,
                  },
                },
                [
                  _vm.isPICAndNotSent
                    ? _c("HKLInput", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                          {
                            name: "fusioninputcheck",
                            rawName: "v-fusioninputcheck",
                            value: {
                              type: "string",
                              required: true,
                            },
                            expression:
                              "{\n          type: 'string',\n          required: true\n        }",
                          },
                        ],
                        staticClass: "hkl-input-with-95",
                        model: {
                          value: _vm.displaySubject,
                          callback: function ($$v) {
                            _vm.displaySubject = $$v
                          },
                          expression: "displaySubject",
                        },
                      })
                    : _vm._e(),
                  _vm._v("\n      " + _vm._s(_vm.displaySubject) + "\n    "),
                ],
                1
              ),
              _vm._v(" "),
              _vm.canEditRecipients
                ? _c("EmailGroupEditor", {
                    model: {
                      value: _vm.receivers,
                      callback: function ($$v) {
                        _vm.receivers = $$v
                      },
                      expression: "receivers",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHKlandUser && _vm.shouldShowReceivers
        ? _c("CommentsPreviewBodyRecipients", {
            attrs: { receivers: _vm.receivers },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CommentsPreviewBody", {
        attrs: {
          isBatchesView: false,
          activeBatch: _vm.activeBatch,
          showRecipientsReadOnly: true,
        },
      }),
      _vm._v(" "),
      _c("TenantSubmissionDocuments", {
        attrs: {
          files: _vm.files,
          sourceId: _vm.previewDataId,
          canEdit: false,
        },
        on: {
          "update:files": function ($event) {
            _vm.files = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row align-right nav_btn" },
        [
          _vm.canEditRecipients
            ? _c("HKLButton", {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                attrs: { color: "darkblue", action: "save" },
                on: {
                  click: function ($event) {
                    return _vm.saveReceivers()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canSend
            ? _c("HKLButton", {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                attrs: {
                  color: "orange",
                  action: _vm.hasSend ? "resend" : "send",
                },
                on: {
                  click: function ($event) {
                    return _vm.sendToReceivers()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isHKlandUser ? _c("GreenFitOutSendHistory") : _vm._e(),
      _vm._v(" "),
      _vm.isHKlandUser ? _c("GreenFitOutReviewerHistory") : _vm._e(),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [_c("div")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }